/** Onboarding (App-Onboarding.dc.html) — 3 pași profil afacere; „Sari peste" (completabil din Setări). */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateBusinessProfile } from '../api/endpoints';
import { useMutation } from '../api/hooks';
import { humanError } from '../api/client';
import { useToast } from '../context/ToastContext';
import { Logo } from '../components/Logo';
import { Spinner } from '../components/ui';

const TONES = [
  { value: 'prietenos', label: 'Prietenos' },
  { value: 'profesional', label: 'Profesional' },
  { value: 'energic', label: 'Energic' },
  { value: 'premium', label: 'Premium' },
];

export function OnboardingPage() {
  const navigate = useNavigate();
  const toast = useToast();
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({ name: '', siteUrl: '', description: '', tone: 'prietenos', audience: '' });

  useEffect(() => {
    document.title = 'Configurare cont — Reclame Video';
  }, []);

  const save = useMutation({
    mutationFn: () =>
      updateBusinessProfile({
        name: form.name || undefined,
        siteUrl: form.siteUrl || undefined,
        description: form.description || undefined,
        tone: form.tone as never,
        targetAudiences: form.audience ? form.audience.split(',').map((s) => s.trim()).filter(Boolean) : undefined,
      }),
    onSuccess: () => {
      toast.push({ kind: 'ok', title: 'Profil salvat' });
      navigate('/dashboard', { replace: true });
    },
    onError: (err) => toast.push({ kind: 'err', title: 'Eroare', body: humanError(err) }),
  });

  const steps = [
    {
      title: 'Despre afacerea ta',
      body: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label className="label">Numele afacerii<input className="input" data-testid="biz-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Bistro „La Nucu”" /></label>
          <label className="label">Site (opțional — importăm automat datele)<input className="input" value={form.siteUrl} onChange={(e) => setForm({ ...form, siteUrl: e.target.value })} placeholder="https://afacereata.ro" /></label>
          <label className="label">Ce faceți, pe scurt<textarea className="input" rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Bistro de cartier cu preparate de casă." /></label>
        </div>
      ),
    },
    {
      title: 'Ce ton ți se potrivește?',
      body: (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {TONES.map((t) => (
            <button key={t.value} className="chip" data-on={form.tone === t.value} onClick={() => setForm({ ...form, tone: t.value })}>
              {t.label}
            </button>
          ))}
        </div>
      ),
    },
    {
      title: 'Cui te adresezi?',
      body: (
        <label className="label">Publicul tău (separă cu virgulă)<input className="input" value={form.audience} onChange={(e) => setForm({ ...form, audience: e.target.value })} placeholder="familii, tineri, corporatiști la prânz" /></label>
      ),
    },
  ];

  const last = step === steps.length - 1;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '28px 16px' }}>
      <div style={{ display: 'inline-flex', gap: 10, alignItems: 'center', marginBottom: 22 }}>
        <Logo withWordmark />
      </div>
      <div className="card rv-in" style={{ width: 'min(460px, 100%)', padding: 26 }}>
        <div style={{ display: 'flex', gap: 5, marginBottom: 18 }}>
          {steps.map((_, i) => (
            <span key={i} style={{ flex: 1, height: 5, borderRadius: 3, background: i <= step ? 'var(--accent)' : 'var(--bg2)' }} />
          ))}
        </div>
        <h1 className="bricolage" style={{ fontSize: 23, fontWeight: 800 }}>{steps[step]!.title}</h1>
        <p style={{ margin: '6px 0 18px', fontSize: 13, color: 'var(--muted)' }}>Pasul {step + 1} din {steps.length} — datele intră automat în scenariile AI.</p>
        {steps[step]!.body}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, gap: 12 }}>
          <button className="btn" style={{ color: 'var(--muted)', fontWeight: 800, fontSize: 13 }} onClick={() => navigate('/dashboard', { replace: true })}>
            Sari peste
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            {step > 0 && <button className="btn btn-ghost btn-sm" onClick={() => setStep((s) => s - 1)}>Înapoi</button>}
            {last ? (
              <button className="btn btn-primary btn-sm" data-testid="onboarding-finish" onClick={() => save.mutate()} disabled={save.isPending}>
                {save.isPending ? <Spinner /> : 'Gata, intră în studio'}
              </button>
            ) : (
              <button className="btn btn-primary btn-sm" onClick={() => setStep((s) => s + 1)}>Continuă →</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
